/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessName } from './ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessName';
import {
    ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessNameFromJSON,
    ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessNameFromJSONTyped,
    ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessNameToJSON,
} from './ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessName';
import type { ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesForeignAddress } from './ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesForeignAddress';
import {
    ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesForeignAddressFromJSON,
    ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesForeignAddressFromJSONTyped,
    ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesForeignAddressToJSON,
} from './ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesForeignAddress';
import type { ExecRiskUSAddress } from './ExecRiskUSAddress';
import {
    ExecRiskUSAddressFromJSON,
    ExecRiskUSAddressFromJSONTyped,
    ExecRiskUSAddressToJSON,
} from './ExecRiskUSAddress';

/**
 * 
 * @export
 * @interface ExecRiskBooksInCareOfDetail
 */
export interface ExecRiskBooksInCareOfDetail {
    /**
     * 
     * @type {string}
     * @memberof ExecRiskBooksInCareOfDetail
     */
    PersonNm?: string;
    /**
     * 
     * @type {ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessName}
     * @memberof ExecRiskBooksInCareOfDetail
     */
    BusinessName?: ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessName;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskBooksInCareOfDetail
     */
    PhoneNum?: string;
    /**
     * 
     * @type {ExecRiskUSAddress}
     * @memberof ExecRiskBooksInCareOfDetail
     */
    USAddress?: ExecRiskUSAddress;
    /**
     * 
     * @type {ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesForeignAddress}
     * @memberof ExecRiskBooksInCareOfDetail
     */
    ForeignAddress?: ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesForeignAddress;
}

/**
 * Check if a given object implements the ExecRiskBooksInCareOfDetail interface.
 */
export function instanceOfExecRiskBooksInCareOfDetail(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ExecRiskBooksInCareOfDetailFromJSON(json: any): ExecRiskBooksInCareOfDetail {
    return ExecRiskBooksInCareOfDetailFromJSONTyped(json, false);
}

export function ExecRiskBooksInCareOfDetailFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskBooksInCareOfDetail {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'PersonNm': !exists(json, 'PersonNm') ? undefined : json['PersonNm'],
        'BusinessName': !exists(json, 'BusinessName') ? undefined : ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessNameFromJSON(json['BusinessName']),
        'PhoneNum': !exists(json, 'PhoneNum') ? undefined : json['PhoneNum'],
        'USAddress': !exists(json, 'USAddress') ? undefined : ExecRiskUSAddressFromJSON(json['USAddress']),
        'ForeignAddress': !exists(json, 'ForeignAddress') ? undefined : ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesForeignAddressFromJSON(json['ForeignAddress']),
    };
}

export function ExecRiskBooksInCareOfDetailToJSON(value?: ExecRiskBooksInCareOfDetail | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'PersonNm': value.PersonNm,
        'BusinessName': ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessNameToJSON(value.BusinessName),
        'PhoneNum': value.PhoneNum,
        'USAddress': ExecRiskUSAddressToJSON(value.USAddress),
        'ForeignAddress': ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesForeignAddressToJSON(value.ForeignAddress),
    };
}

